import { render } from "./ClientDocuments.vue?vue&type=template&id=927fb368&scoped=true"
import script from "./ClientDocuments.vue?vue&type=script&lang=js"
export * from "./ClientDocuments.vue?vue&type=script&lang=js"

import "./ClientDocuments.vue?vue&type=style&index=0&id=927fb368&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-927fb368"]])

export default __exports__